// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CarHireTermsAndConditions-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarHire/CarHireTermsAndConditions.desktop.scss
 ** module id = 902
 ** module chunks = 1
 **/